import { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { App as KonstaApp } from 'konsta/react';
import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';
import { supabase } from './lib/supabase';
import BottomNav from './components/BottomNav';

/**
 * Root layout component.
 * Konsta App wrapper + persistent BottomNav + Outlet for routed pages.
 * Includes Auth Guard logic to force login on app install.
 */
function App() {
  const theme = Capacitor.getPlatform() === 'ios' ? 'ios' : 'material';
  const navigate = useNavigate();
  const [checkingAuth, setCheckingAuth] = useState(true);

  useEffect(() => {
    const initTheme = async () => {
      try {
        const { value: savedTheme } = await Preferences.get({ key: 'theme' });
        document.documentElement.classList.toggle('dark-mode', savedTheme === 'dark');
      } catch (e) {
        console.error('Eroare la inițializarea temei:', e);
      }
    };
    initTheme();

    const checkSession = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        navigate('/login', { replace: true });
      } else {
        setCheckingAuth(false);
      }
    };

    checkSession();

    // Ascultă evenimentele de autentificare Supabase în timp real
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      if (!session) {
        navigate('/login', { replace: true });
      } else {
        setCheckingAuth(false);
      }
    });

    return () => {
      subscription.unsubscribe();
    };
  }, [navigate]);

  if (checkingAuth) {
    return (
      <div className="flex-center" style={{ height: '100vh', backgroundColor: 'var(--dds-bg-secondary)' }}>
        <div className="skeleton" style={{ width: '80px', height: '80px', borderRadius: '50%' }} />
      </div>
    );
  }

  return (
    <KonstaApp theme={theme} safeAreas>
      <div className="app-content">
        <Outlet />
      </div>
      <BottomNav />
    </KonstaApp>
  );
}

export default App;
